import { PrefillEditFieldDefinition, createPrefillEditField } from './prefillFieldSettingsUtils'
import { normalizePrefillEditFieldIds } from './tableFieldUtils'

export const hasConditionalRenderFields = (element: {
  conditionalRenderFields?: PrefillEditFieldDefinition[]
}): boolean =>
  Array.isArray(element?.conditionalRenderFields) && element.conditionalRenderFields.length > 0

export const getConditionalRenderFields = (element: {
  conditionalRenderFields?: PrefillEditFieldDefinition[]
  fieldId?: number
}): PrefillEditFieldDefinition[] =>
  normalizePrefillEditFieldIds(
    Array.isArray(element?.conditionalRenderFields) ? element.conditionalRenderFields : [],
    element?.fieldId
  )

export const createConditionalRenderField = (
  parentFieldId: number,
  existingFields: PrefillEditFieldDefinition[],
  type = 'text'
): PrefillEditFieldDefinition => createPrefillEditField(parentFieldId, existingFields, type)

export const CONDITIONAL_TRIGGER_FIELD_TYPES = new Set([
  'text',
  'email',
  'tel',
  'url',
  'password',
  'number',
  'textarea',
  'select',
  'radio',
  'checkbox',
  'switch',
  'date',
  'time',
  'datetime',
  'daterange',
  'ratings'
])

export const isConditionalTriggerField = (element: { type?: string; fieldId?: number }): boolean =>
  !!element?.type &&
  CONDITIONAL_TRIGGER_FIELD_TYPES.has(element.type) &&
  Number.isFinite(Number(element.fieldId))

export const getOperatorOptions = (type?: string): string[] =>
  type === 'checkbox' ? ['=', '!=', 'has selections'] : ['<', '>', '=', '!=']

export const isSelfTriggeredConditionalRender = (element: {
  fieldId?: number
  conditionalRenderFields?: PrefillEditFieldDefinition[]
  includeOnCondition?: { basedOnElementOfIndex?: number | null }
}): boolean =>
  hasConditionalRenderFields(element) &&
  Number(element.includeOnCondition?.basedOnElementOfIndex) === Number(element.fieldId)
